import { render, staticRenderFns } from "./SettingsTitle.vue?vue&type=template&id=539f9b45&"
import script from "./SettingsTitle.vue?vue&type=script&lang=js&"
export * from "./SettingsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports